import { datadogRum } from "@datadog/browser-rum"
import globals from "@/utils/globals"

const createErrorAndMessage = (messageOrError) => {
  let message, error
  if (messageOrError instanceof Error) {
    message = messageOrError.toString()
    error = messageOrError
  } else if (typeof messageOrError === "string" || messageOrError instanceof String) {
    message = messageOrError
    error = new Error(messageOrError)
  } else {
    message = `Unknown object passed to notify. Type: ${typeof messageOrError}`
    error = new Error(message)
    try {
      error.content = JSON.stringify(messageOrError)
    } catch (_) {
      error.content = "Couldn't serialize the unknown object into JSON."
    }
  }

  return { error, message }
}

export default (messageOrError, options = {}) => {
  let { error } = createErrorAndMessage(messageOrError)

  if (globals.env === "production") {
    datadogRum.addError(error, {
      severity: options.isWarning ? "warning" : "error"
    })
  } else {
    console.error(error)
  }
}
